import { Component, OnInit, Output, EventEmitter, Renderer2 } from '@angular/core';
import templateString from './reportChangeOrder.component.html';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  template: templateString, host: {'forUniqueComponentId': 'la;meoajeoijao'}
})
export class ReportChangeOrderComponent implements OnInit {
    @Output() action = new EventEmitter();
    
    public originalReports: any;
    
    public reports: any;

    constructor(
        private http: HttpClient,
        private bsModalRef: BsModalRef,
        private renderer: Renderer2
    ) { 
        this.renderer.addClass(document.body, 'md-skin');
		this.renderer.addClass(document.body, 'landing-page');
		this.renderer.addClass(document.body, 'fixed-nav');
    }

    ok() {
        this.http.post("reports/update_order", { report_ids: this.reports.map(function(x) { return x.id; }) }).subscribe(() => {
            this.action.emit(true);
            this.bsModalRef.hide();
		});
    }

    cancel() {
        this.bsModalRef.hide();
    };

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.reports, event.previousIndex, event.currentIndex);
    }

    ngOnInit() {
        this.reports = JSON.parse(JSON.stringify(this.originalReports));
    }
}
